import * as React from "react";
const SvgLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9, height: 16, viewBox: "0 0 9 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M 8 16 L 1.4142 9.4142 C 0.6332 8.6332 0.6332 7.3668 1.4142 6.5858 L 8 0 L 9 0 L 9 16 Z", fill: "currentColor" }));
export default SvgLeft;
